module.exports = __webpack_public_path__ + "static/media/29COICT6.974f13ff.jpg";